const useLocal = false;
const localUrl = "http://localhost:3000";
const hostedUrl = "https://dolphin-app-on7cp.ondigitalocean.app";

export const URL_BASE = useLocal ? localUrl : hostedUrl;
export const WEBSITE_URL = "https://chat.onuro.ai";
export const LANDING_PAGE_URL = "https://onuro.ai";

export const LIGHT_THEME_COLOR = 'bg-neutral-100';
export const DARK_THEME_COLOR = 'dark:bg-neutral-900';
export const THEME_COLORS = `${LIGHT_THEME_COLOR} ${DARK_THEME_COLOR} text-neutral-700 dark:text-neutral-100`;
export const DEFAULT_CONTEXT_GATHER_PROVIDER = "Google";
export const DEFAULT_CONTEXT_GATHER_MODEL = "Gemini-Flash";
export const DEFAULT_MODEL = "Automatic";
export const DEFAULT_CLAUDE_SONNET_REASONING_EFFORT = "Automatic";
export const DEFAULT_CLAUDE_OPUS_REASONING_EFFORT = "Automatic";
export const DEFAULT_VOICE = "Ellen";
export const DEFAULT_THEME = "auto";
export const DEFAULT_ENVIRONMENT = "web";
export const DEFAULT_PRIMARY_LANGUAGE = "English";
export const DEFAULT_SECONDARY_LANGUAGE = null;
export const DEFAULT_SEND_MESSAGE_PHRASE = "Send Message";
export const DEFAULT_STOP_OUTPUT_PHRASE = "Stop Output";
export const DEFAULT_STOP_RECORDING_PHRASE = "Stop Recording";

export const getDefaultSessionUsageForModel = () => ({
    input_tokens: 0,
    output_tokens: 0,
    input_audio_tokens: 0,
    output_audio_tokens: 0,
    reasoning_tokens: 0,
    cache_creation_input_tokens: 0,
    cache_read_input_tokens: 0,
    total_tokens: 0,

    input_charges: 0.0,
    output_charges: 0.0,
    input_audio_charges: 0,
    output_audio_charges: 0,
    reasoning_charges: 0,
    cache_creation_input_charges: 0,
    cache_read_input_charges: 0,
    total_charges: 0.0
});
export const getDefaultLlmRequestRefs = () => ({
    intervalId: null,
    toolCalls: {},
    lastToolUsed: null,
    aiMessage: null,
    userMessage: null,
    toolMessages: [],
    parentMessage: null,
    additionalContext: {
        mostRecentFileStates: {},
        toolCallAdjustments: {},
        serverResponseResults: {},
        filesAlreadySeen: new Set(),
        urlsAlreadySeen: new Set()
    },
    messagesToWrite: [],
    mediaWritePromises: [],
    aiTurnCounter: 0,
    toolCallQueue: [],
    streamId: null,
    topLevelFiles: null,
    wsFinishedToolCall: null
});

export const DEFAULT_MISC_MID_RENDER_REFS = {
    playingId: null,
    embeddingBatchQueue: [],
    audioChunks: [],
    mediaRecorder: null as MediaRecorder | null,
    stream: null,
    ideResponseTimeouts: {} as Record<string, ReturnType<typeof setTimeout>>
};
